<template>
    <b-modal id="paymentModal" :hide-footer="true">
    	<!-- <pre>{{validVA}}</pre> -->
        <div id="paymentForm" v-if="transactionData">
					<div class="formTitle">
						<svg-image image="iconPay"/>
						<h5>{{ $t("payment.head") }}</h5>
					</div>
					
					<div class="invoiceDetails text-center">
						<h1>{{ $t("payment.currency") }} {{transactionData.data.trnsAmount}}</h1>
						<h6>{{ $t("payment.code") }}: {{transactionData.data.trnsRefId}}</h6>
						<p>{{ $t("payment.limit") }}: <strong>{{transactionData.data.trnsExpiredTime | moment("D MMMM YYYY HH:mm")}} WIB (GMT+7)</strong></p>
						<!-- <p>Will expire in <strong>{{transactionData.data.trnsExpiredTime | moment("from", "now")}}</strong></p> -->
					</div>

					<alert :status="status"/>

					<div class="couponCode">
						<b-input-group>
								<b-form-input
									id="coupon"
									type="text"
									required
									:placeholder="$t('payment.code')"
								></b-form-input>
								<b-input-group-append>
									<b-button variant="primary">
										<b-spinner small v-if="applyingCoupon"></b-spinner>
										<span> {{ $t("payment.apply") }}</span>
									</b-button>
								</b-input-group-append>
								<!-- <b-spinner medium type="grow"></b-spinner> -->
						</b-input-group>
					</div>

					<div class="groupLabel text-center"><label>{{ $t("payment.pay") }}</label></div>
					<div class="paymentMethod">
						<a href="" payment-id="6" id="snap_cc_bri" @click.prevent="doPay(22)">
							<div class="btn-pay btn-cc">
								<b-row>
									<b-col v-html="$t('payment.paycc')">
									</b-col>
									<b-col sm="auto" class="arrow">
										<b-icon icon="arrow-right" font-scale="3"></b-icon>
									</b-col>
								</b-row>
							</div>
						</a>
						<a href="" payment-id="10" id="virtual_account_jateng" @click.prevent="doPay(10)" v-if="!validVA">
						<!-- <a href="" payment-id="10" id="virtual_account_jateng" @click.prevent="doPay(10)"> -->
							<div class="btn-pay btn-bt">
								<b-row>
									<b-col v-html="$t('payment.paybt')">
									</b-col>
									<b-col sm="auto" class="arrow">
										<b-icon icon="arrow-right" font-scale="3"></b-icon>
									</b-col>
								</b-row>
							</div>
						</a>
					</div>

					<div class="bankTransferDetails" v-if="validVA">
						<div class="groupLabel text-center"><label>{{ $t("payment.trans") }}</label></div>
						<div class="banktransferDetails text-center">
							<img src="https://assets.heartwork.co.id/bormar/bankjateng.svg" class="bankJateng">
							<h6>{{ $t("payment.va") }}</h6>
							<h4>{{validVA.jtvaVANumber}}</h4>
							<!-- <b-button pill variant="outline-secondary" size="sm" @click.prevent="copyToClipboard(validVA.jtvaVANumber)">Copy to clipboard</b-button> -->
							<p>{{ $t("payment.swift") }}: <a href="https://www.theswiftcodes.com/indonesia/pdjgidja/" target="_blank">PDJGIDJA</a></p>
						</div>
						<div role="tablist">
							<b-card no-body>
							<b-card-header header-tag="header" role="tab">
								<b-button block href="#" v-b-toggle.accordion-bj><img class="atm-logo" src="https://assets.heartwork.co.id/bormar/atm-bankjateng.png"> ATM Bank Jateng</b-button>
							</b-card-header>
							<b-collapse id="accordion-bj" visible accordion="my-accordion" role="tabpanel">
								<b-card-body v-html="$t('payment.atmbj')">
									
								</b-card-body>
							</b-collapse>
							</b-card>

							<b-card no-body>
							<b-card-header header-tag="header" role="tab">
								<b-button block href="#" v-b-toggle.accordion-ab><img class="atm-logo" src="https://assets.heartwork.co.id/bormar/atmbersama.png"> ATM Bersama</b-button>
							</b-card-header>
							<b-collapse id="accordion-ab" visible accordion="my-accordion" role="tabpanel">
								<b-card-body v-html="$t('payment.atmb')">
									
								</b-card-body>
							</b-collapse>
							</b-card>

							<b-card no-body>
							<b-card-header header-tag="header" role="tab">
								<b-button block href="#" v-b-toggle.accordion-bp><img class="atm-logo" src="https://assets.heartwork.co.id/bormar/atmprima.png"> ATM BCA/Prima</b-button>
							</b-card-header>
							<b-collapse id="accordion-bp" visible accordion="my-accordion" role="tabpanel">
								<b-card-body v-html="$t('payment.atmp')">

								</b-card-body>
							</b-collapse>
							</b-card>
						</div>
					</div>
			
		</div>
    </b-modal>
</template>
<script>
  import SvgImage from '../components/SvgImage.vue';
	import VuePhoneNumberInput from 'vue-phone-number-input';
   	import Alert from '../components/Alert.vue'
	import { gmapApi } from '../../node_modules/vue2-google-maps'
	import * as utils from '../util/utils'

	export default {
		data() {
			return {
				modalShow: false,
				progress: 0,
				idFile: undefined,
				progressAction: undefined,
				signedin : true,
				data: null,
				status: null,
				loading:false,
				checkingPhone: false,
				applyingCoupon: undefined
				// transactionData: undefined
			}
		},
		computed : {
			isLoggedIn : function(){ 
				// console.log('is this one logged in? ', this.$store.getters.isLoggedIn);
				return this.$store.getters.isLoggedIn
			},
			validVA : function(){
				if (this.transactionData.linked.jtvaTrnsId&&this.transactionData.linked.jtvaTrnsId.length > 0){
					return this.transactionData.linked.jtvaTrnsId[this.transactionData.linked.jtvaTrnsId.length-1];
				} else {
					return false;
				}
			}
		},
		components : {
			Alert,
			gmapApi,
			VuePhoneNumberInput,
			SvgImage,
		},
		methods: {
			doPay(paymentType){
				console.log('Checkout using payment id : ', this.transactionData.data, paymentType);
				this.$store.dispatch('CHECKOUT',{ data : {
					transactionId : this.transactionData.data.trnsId, 
					paymentType : paymentType
				}}).then(checkOutOutput=>{
					if (paymentType==22){					
						snap.pay(checkOutOutput.data.linked.vrtrTrnsId[0].vrtrURL, {
							language : 'en',
							onSuccess: function(result){
								function doCheck(){									
									checkTransaction(refId).done(function(txOut){
										if (txOut&&txOut.data&&txOut.data.trnsConfirmed&&txOut.data.trnsConfirmed==1){
											location.reload();
										} else {
											console.log('Uncomfirmed');
											doCheck();
										}
									})
								};
								doCheck();
							},
							onPending: function(result){
							},
							onError: function(result){
							},
							onClose: function(){
							}
						})
					} else {
						console.log('Payment output : ', checkOutOutput);
						this.transactionData = checkOutOutput.data;
					}
				}).catch(err=>{
					console.log('Payment selection error : ', err.response);
					if (err.response){
						this.status = err.response;						
					}
				})

			},
			handleFileUpload(e){
				console.log(e)
			},
			parseError(err){
				if (err.response&&err.response.data&&err.response.data.status&&err.response.data.status.error){
					console.log('E1: ', err.response.data.status.error)
					console.log('E2: ', err.response.data.status.error.errors)
					if (err.response.data.status.error.errors&&err.response.data.status.error.errors.length > 0){
						err.response.data.status.error.errors.forEach((errors)=>{
							console.log('E3: ', errors);
							if (Array.isArray(errors)){
								errors.forEach((error)=>{
									console.log('E4: ', error);	
									this.formStatus[error.field].state = false;
									this.formStatus[error.field].message = error.message;
								})
							}
						})
					}
				}
			},
			
			onFile(evt){
				this.loading = true;
				evt.preventDefault()
				this.progressAction = 'Uploading File...';
				let formData = new FormData();
				formData.append('file',this.idFile);
				// console.log(formData);
				this.$store.dispatch('UPLOADID', {data:formData, progressEvent:(progressEvent)=>{
					this.progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ))
					// console.log('progress : ', this.progress)
				}}).then((uploadOut) =>{
						this.loading = true;
						var fileUploadOut = uploadOut.data;
						console.log('Upload success : ', fileUploadOut);
						var dataToExtract = {
							url : fileUploadOut.file.path,
							cardtype : this.form.mbsdIDNumberType
						}
						this.form.mbsdFile = fileUploadOut.file.path;
						this.progressAction = 'Validating File...';
						this.progress = 150;
						this.$store.dispatch('EXTRACTID', {data:dataToExtract})
							.then((extractionOut) =>{
								this.loading = false;
								this.progress = 200;
								this.progressAction = 'File processed!';
								console.log('output of extraction : ', extractionOut.data)
								this.form.mbsdIDNumber = extractionOut.data.data.nik;
								this.form.mbsdBirthDate = extractionOut.data.data.tanggal_lahir.split("-").reverse().join("-");
								this.form.mbsdBirthPlace = extractionOut.data.data.tempat_lahir;
								this.form.mbsdNationality = 'Indonesia';
								this.form.mbsdCountry = 'Indonesia';
								this.form.mbsdProvinces =  extractionOut.data.data.province;
								this.form.mbsdCity = extractionOut.data.data.city;
								this.form.mbsdAddress = extractionOut.data.data.alamat;
								this.form.mbsdRawAddress = JSON.stringify(extractionOut);
								// "mbsdFile": 'MUSTVALIDATE'
								// this.$router.push('/signup/otp')
								// this.init();
							})
							.catch(err => {
								// this.parseError(err);
								if (err.response){
									this.status = err.response;
								}
								this.loading = false;
							})
						// var 
						// this.$router.push('/signup/otp')
						// this.init();
					})
					.catch(err => {
						this.parseError(err);
						// if (err.response){
						// 	this.status = err.response;
						// }
						this.loading = false;
					})

			},
			onPhone(evt){
				evt.preventDefault()
			},
			onData(evt){
				this.loading = true;
				evt.preventDefault()

				console.log('Do profile... ', this.form);
				this.$store.dispatch('SETPROFILE', {data:this.form})
					.then((signUp) =>{
						this.loading = false;
						console.log(signUp)
						// this.$router.push('/signup/otp')
						// this.init();
					})
					.catch(err => {
						this.parseError(err);
						if (err.response){
							this.status = err.response;
						}
						this.loading = false;
					})

			},
			phoneUpdated(value){
				this.formPhone.mbspCountryCode = value.countryCallingCode;
				this.formPhone.mbspNumber = value.phoneNumber;
				// console.log(value);
			},
			sendOTP(event){
				console.log(this.formPhone)
				this.$store.dispatch('ADDPHONE', {data:this.formPhone})
					.then((addPhone) =>{
						this.loading = false;
						console.log(addPhone)
						// this.$router.push('/signup/otp')
						// this.init();
					})
					.catch(err => {
						console.log('add phone error : ', err)
						// this.parseError(err);
						if (err.response){
							this.status = err.response;
						}
						this.loading = false;
					})
			},
			copyToClipboard(dataToCopy){
				console.log('Copy this to clipboard : ', dataToCopy)
			}
		},
		props: {
			transactionData:Object
		},
		mounted(){
			console.log('transaction data : ', this);
			let snapScript = document.createElement('script')
			snapScript.setAttribute('src', 'https://app.midtrans.com/snap/snap.js')
			snapScript.setAttribute('data-client-key', 'VT-client-OFSiti-I0DxpWdmo')
			document.head.appendChild(snapScript)
			// this.transactionData = this.$store.getters.getCurrentTransaction;
			// this.userProfile = this.$store.getters.getUserProfile;
			// this.$store.dispatch('CHECK')
			// 	.then((checkOut) =>{
			// 		// console.log(checkOut);
			// 		this.data = checkOut.data;
			// 		this.$store.dispatch('GETPROFILE')
			// 			.then((profileOut)=>{
			// 				console.log(profileOut);
			// 				this.$store.commit('SET_USER', {id: profileOut.data.data[0].id, user: profileOut.data});
			// 			})
			// 			.catch((err)=>{
			// 				console.log('profile error : ', err)
			// 			})
			// 	})
			// 	.catch(err => {
			// 		console.log(err);
			// 	})
		},
	}
</script>


// WEBPACK FOOTER //
// PaymentModal.vue